const WHATSAPP_URL = 'https://wa.me/59173455233';

export default function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#128C7E] text-white flex items-center justify-center shadow-lg hover:scale-110 transition-all duration-300 animate-float"
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-fill text-3xl" />
    </a>
  );
}